<template>
  <div class="static-wrap">
    <Header @openFreeTrial="openFreeTrial"></Header>
    <slot></slot>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";
export default {
  data() {
    return {};
  },
  methods: {
    goPage(path) {
      if (path === this.$route.path) return;
      this.$router.push(path);
    },
    openFreeTrial() {
      this.$emit("openFreeTrial");
    }
  },
  mounted() {},
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="scss">
@import "../assets/stylesheets/front_page";
</style>



// WEBPACK FOOTER //
// src/components/FrontPageTmpl.vue